import { gql } from '@urql/core'

export const LINK_WALLET_MUTATION = gql`
  mutation LinkWalletMutation($input: LinkWalletInput!) {
    linkWallet(input: $input)
  }
`
